module.exports = __webpack_public_path__ + "img/20200121.4ca36798.png";